import axios from 'axios';
import { buildCxApiUrl, CX_API_ENDPOINTS } from '../config/cxApiConfig';

export interface TenantRoutingResolution {
  companyId?: number;
  companyImageUrl?: string;
  companyName?: string;
  faviconUrl?: string;
  host: string;
  tenantSlug?: string;
  websiteUrl?: string;
}

export async function resolveTenantRouting(
  host: string,
  tenantSlug: string
): Promise<TenantRoutingResolution | null> {
  try {
    const response = await axios.get<TenantRoutingResolution>(
      buildCxApiUrl(CX_API_ENDPOINTS.PUBLIC_TENANT_RESOLVE),
      { params: { host, tenant: tenantSlug } }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return null;
    }

    throw error;
  }
}
